import { PulseEnvironment } from '../globals';

export class PageInfoService {
    constructor(private env: PulseEnvironment) {}

    host(): string | undefined {
        return this.env.win.location.host;
    }

    landingPageUrl(): string {
        return this.env.landingUrl.toLowerCase();
    }

    referrer(): string {
        return this.env.doc.referrer;
    }

    href() {
        return this.env.win.location.href;
    }

    url() {
        return new URL(this.env.win.location.href);
    }
}
